import React, { useEffect } from "react";
import { useSEO } from "../../context/SEOContext";
import { useTranslation } from "react-i18next";
const ShippingAndDelivery = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: `${t("ShippingAndDeliveryTitle")} | Mükemel`,
      description: t("shipping.meta.description"),
      keywords: t("shipping.meta.keywords"),
      favicon: "/faviconnew.png",
    });
  }, [setSeo, t]);

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-lg-12 mb-5 text-center">
          <h4 className="fw-light">{t("ShippingAndDeliveryTitle")}</h4>
        </div>
        <div className="col-lg-12">
          <h4 className="mb-3 fw-normal">{t("DeliveryTitle")}</h4>
          <ul>
            <li>{t("DeliveryDesc1")}</li>
            <li>{t("DeliveryDesc2")}</li>
            <li>{t("DeliveryDesc3")}</li>
            <li>{t("DeliveryDesc4")}</li>
            <li>{t("DeliveryDesc5")}</li>
            <li>{t("DeliveryDesc6")}</li>
          </ul>
          <h4 className="mb-3 fw-normal">{t("DeliveryTimingTitle")}</h4>
          <ul>
            <li>{t("DeliveryTimingDesc1")}</li>
            <li>{t("DeliveryTimingDesc2")}</li>
            <li>{t("DeliveryTimingDesc3")}</li>
            <li>{t("DeliveryTimingDesc4")}</li>
            <li>{t("DeliveryTimingDesc5")}</li>
          </ul>
          <h4 className="mb-3 fw-normal"> {t("PerfumeTimingTitle")}</h4>
          <p>{t("PerfumeTimingIntro")}</p>
          <ul>
            <li>{t("PerfumeTimingDesc1")}</li>
            <li>{t("PerfumeTimingDesc2")}</li>
          </ul>
          <h4 className="mb-3 fw-normal">{t("PackagingTitle")}</h4>
          <ul>
            <li>{t("PackagingDesc1")}</li>
            <li>
              {t("PackagingDesc2")} {t("PackagingDesc3")}
            </li>
          </ul>
          <p>
            {t("PackagingClaimNote")} {t("NoInsuranceNote")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingAndDelivery;
